// App.js
import React from 'react';
import ReactDOM from 'react-dom';
import HomePage from "./HomePage";
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import './App.css';
import PrivacyPage from "./PrivacyPage";
import TermsOfUsePage from "./TermsOfUsePage";
import Navbar from "./Navbar"
import Header from "./Header"
import PressPage from "./PressPage";
import PressArchive2024 from "./PressArchive2024";
import NotFoundPage from "./NotFoundPage";
import NYXNoCode from "./NYXNoCode";
import NyxCatalog from './NyxCatalog'; // Import the NyxCatalog component
import HacktopiaPage from "./HacktopiaPage";
import DemosPage from "./DemosPage";
import HowItWorksPage from "./HowItWorksPage";
import GetStartedPage from "./GetStartedPage";
import EmpowerPage from "./EmpowerPage";
import { HelmetProvider } from 'react-helmet-async';
import Footer from "./Footer";
import MenaWinnerPage from "./MenaWinnerPage";
import MenaHsGallery2025 from "./MenaHsGallery2025";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>
);
function App() {
    return (
       <Router>
           <div className={"App"}>
               <Header />
               <Navbar />
               <Routes>
                   <Route path={"/"} element={<HomePage />} />
                   <Route path={"press"} element={<PressPage />} />
                   <Route path={"press/archive/2024"} element={<PressArchive2024 />} />
                   <Route path={"privacy-policy"} element={<PrivacyPage />} />
                   <Route path={"terms-of-service"} element={<TermsOfUsePage />} />
                   <Route path={"404.html"} element={<NotFoundPage />} />
                     <Route path={"nyx-nocode"} element={<NYXNoCode />} />
                    <Route path={"nyx-catalog"} element={<NyxCatalog />} />
                   <Route path={"hacktopia"} element={<HacktopiaPage />} />
                   <Route path={"demos"} element={<DemosPage />} />
                   <Route path={"how-it-works"} element={<HowItWorksPage />} />
                   <Route path={"get-started"} element={<GetStartedPage />} />
                   <Route path={"empower"} element={<EmpowerPage />} />
                   <Route path={"mena_winner"} element={<MenaWinnerPage />} />
                   <Route path={"mena-hs-2025"} element={<MenaHsGallery2025 />} />

               </Routes>
           </div>
           <Footer />
       </Router>
    );
}

export default App;
